import { Component, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ToastComponent } from '../../../shared/toast/toast.component';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CustomersService } from '../../../../core/services/customer/customers.service';
import { lettersOnlyValidator } from '../../../shared/validators/validators';
import { CurrentUserService } from '../../../../core/services/user/current-user.service';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { ApplicationListModel } from '../../../../core/models/customer/application-list.model';
import { LanguageListModel } from '../../../../core/models/customer/language-list.model';
import { CustomerBranchListModel } from '../../../../core/models/customer/customer-branch-list.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../../../core/services/toast.service';
@Component({
  selector: 'app-create-edit-organization',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ToastComponent,
    SelectDropDownModule,
    RouterModule,
    TranslateModule,
  ],
  templateUrl: './create-edit-organization.component.html',
  styleUrl: './create-edit-organization.component.scss',
})
export class CreateEditOrganizationComponent {
  organizationForm: FormGroup;
  roles: any = [];
  organizationId: string = '';
  specialismList: any = [];
  organizationList: any = [];
  maxDate: string;
  currentUser: any = null;
  dropdownConfig: any = {
    displayKey: 'applicationName',
    valueKey: 'applicationId',
    search: true,
    height: '200px',
    placeholder: this.translate.instant('selectApplication'),
    limitTo: 0,
    moreText: 'more',
  };
  languageDropdownConfig: any = {
    displayKey: 'name',
    valueKey: 'code',
    search: true,
    height: '200px',
    placeholder: this.translate.instant('selectLanguage'),
    limitTo: 0,
    moreText: 'more',
  };

  applyLanguageDropdownConfig: any = {
    displayKey: 'name',
    valueKey: 'value',
    search: true,
    height: '200px',
    placeholder: this.translate.instant('selectLanguageForReports'),
    limitTo: 0,
    moreText: 'more',
  };

  isOverlayLoading: boolean = false;
  applications: ApplicationListModel[] = [];
  languages: LanguageListModel[] = [];
  applyLanguageSelections: Array<{ name: string; value: boolean }> = [];
  deleteModalId: string = '';

  constructor(
    private router: Router,
    private customersService: CustomersService,
    private currentUserService: CurrentUserService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private toastService: ToastService
  ) {
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];
    this.organizationForm = this.fb.group({
      name: ['', [Validators.required, lettersOnlyValidator()]],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      adress: ['', [Validators.required]],
      typeOfOrganization: ['', [Validators.required]],
      corporateAgbVAT: ['', [Validators.required]],
      phone1: [
        '',
        [Validators.required, Validators.pattern('^\\+?[0-9]{7,15}$')],
      ],
      email: ['', [Validators.required, Validators.email]],
      location: ['', [Validators.required]],
      code: ['', [Validators.required]],
      applications: [[], [Validators.required]],
      invoiceEmail: ['', [Validators.required, Validators.email]],
      billingAgbVAT: ['', [Validators.required]],
      financeDepartmentMail: ['', [Validators.required, Validators.email]],
      supportEmail: ['', [Validators.required, Validators.email]],
      billingLocation: ['', [Validators.required]],
      billingState: ['', [Validators.required]],
      billingCountry: ['', [Validators.required]],
      isShippingAddressSameAsBilling: [false],
      isActiveSmsMessages: [false],
      isUsingOwnDermascope: [false],
      languageCode: ['', [Validators.required]],
      applyHeadOfficeLanguage: ['', [Validators.required]],
      sendReportToPatient: [false],
      timeDifference: [
        '',
        [Validators.required, Validators.pattern(/^([+-]?\d+)$/)],
      ],
    });
    this.getLanguages();
    this.getApplyLangugeSelections();
  }

  ngOnInit(): void {
    this.currentUser = this.currentUserService.GetSession();
    this.getOrganizationByCode();
    this.getAllApplications();
  }

  getOrganizationByCode() {
    this.organizationId = this.route.snapshot.paramMap.get('id')!;
    if (this.organizationId) {
      this.customersService.getCustomer(this.organizationId).subscribe({
        next: (res) => {
          this.organizationForm.patchValue({
            name: res.name,
            city: res.city,
            country: res.country,
            adress: res.adress,
            typeOfOrganization: res.typeOfOrganization,
            corporateAgbVAT: res.corporateAgbVAT,
            phone1: res.phone1,
            email: res.email,
            location: res.location,
            code: res.code,
            applications: res.customerApplications,
            invoiceEmail: res.invoiceEmail,
            billingAgbVAT: res.billingAgbVAT,
            financeDepartmentMail: res.financeDepartmentMail,
            supportEmail: res.supportEmail,
            billingLocation: res.billingLocation,
            billingState: res.billingState,
            billingCountry: res.billingCountry,
            isShippingAddressSameAsBilling: res.isShippingAddressSameAsBilling,
            isActiveSmsMessages: res.isActiveSmsMessages,
            isUsingOwnDermascope: res.isUsingOwnDermascope,
            languageCode: this.getOrganizationLanguage(res.languageCode),
            applyHeadOfficeLanguage: this.getOrganizationApplyLanguage(
              res.applyHeadOfficeLanguage
            ),
            sendReportToPatient: res.sendReportToPatient,
            timeDifference: res.timeDifference,
          });
        },
        error: (error) => {
          console.log('error :>> ', error);
        },
      });
    }
    this.organizationForm.patchValue({
      applications: [],
    });
  }

  saveOrganization(e: Event) {
    e.preventDefault();

    if (this.organizationId) {
      const selectedLanguage = this.organizationForm.get('languageCode')?.value;
      if (selectedLanguage && selectedLanguage.code) {
        this.organizationForm.patchValue({
          languageCode: selectedLanguage.code,
        });
      }

      const selectedApplyLanguage = this.organizationForm.get(
        'applyHeadOfficeLanguage'
      )?.value;
      this.organizationForm.patchValue({
        applyHeadOfficeLanguage: selectedApplyLanguage.value,
      });

      // Edit organization
      if (this.organizationForm.valid) {
        this.isOverlayLoading = true;

        const editData = this.covertToFormData();
        this.customersService
          .editCustomer(this.organizationId, editData)
          .subscribe({
            next: () => {
              setTimeout(() => {
                this.toastService.showToast(
                  this.translate.instant('organizationEditedSuccessfully'),
                  'success'
                );
                setTimeout(() => {
                  this.router.navigate(['/organization/list']);
                }, 2000);
              }, 200);
            },
          });
      } else {
        this.toastService.showToast(
          this.translate.instant(
            'allFieldsAreRequiredAndMustBeFilledWithValidValues'
          ),
          'warning'
        );
        this.organizationForm.markAllAsTouched();
      }
    } else {
      // Create new organization
      if (this.organizationForm.valid) {
        const selectedLanguage =
          this.organizationForm.get('languageCode')?.value;
        if (selectedLanguage && selectedLanguage.code) {
          this.organizationForm.patchValue({
            languageCode: selectedLanguage.code,
          });
        }

        const selectedApplyLanguage = this.organizationForm.get(
          'applyHeadOfficeLanguage'
        )?.value;
        this.organizationForm.patchValue({
          applyHeadOfficeLanguage: selectedApplyLanguage.value,
        });
        this.isOverlayLoading = true;

        const createData = this.covertToFormData();
        this.customersService.createCustomer(createData).subscribe({
          next: () => {
            setTimeout(() => {
              this.toastService.showToast(
                this.translate.instant('organizationCreatedSuccessfully'),
                'success'
              );
              setTimeout(() => {
                this.router.navigate(['/organization/list']);
              }, 2000);
            }, 200);
          },
        });
      } else {
        this.toastService.showToast(
          this.translate.instant(
            'allFieldsAreRequiredAndMustBeFilledWithValidValues'
          ),
          'warning'
        );
        this.organizationForm.markAllAsTouched();
      }
    }
  }

  getAllApplications() {
    this.customersService.allApplications().subscribe({
      next: (res) => {
        this.applications = res.map((item: any) => ({
          applicationId: item.id,
          applicationName: item.name,
        }));

        if (this.organizationId) {
          // Edit
          this.organizationForm.patchValue({
            applications: this.applications,
          });
        } else {
          // Create
          this.organizationForm.patchValue({
            applications: [],
          });
        }
      },
    });
  }

  getLanguages() {
    this.languages = this.customersService.allLanguages();
  }

  getApplyLangugeSelections() {
    this.applyLanguageSelections =
      this.customersService.applyLanguageSelection();
  }

  onApplicationSelect(event: any) {
    const appValues = event?.value;
    this.applications = [...new Set(this.applications)];
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.organizationForm.get(controlName);
    if (
      controlName === 'applyHeadOfficeLanguage' &&
      Array.isArray(control?.value) &&
      control.value.length === 0
    ) {
      control.setErrors({ required: true });
      return false;
    }
    return control ? control.invalid && control.touched : false;
  }

  getOrganizationLanguage(languageCode: string): any {
    return this.languages.find((item) => item.code == languageCode);
  }

  getOrganizationApplyLanguage(applyHeadOffice: boolean): any {
    return this.applyLanguageSelections.find(
      (item) => item.value == applyHeadOffice
    );
  }

  private covertToFormData(): FormData {
    const customerApplications = this.organizationForm.value.applications
      .map((app: any) => app.applicationId)
      .join(',');

    const formData = new FormData();
    if (this.organizationId) {
      formData.append('Id', this.organizationId);
    }
    formData.append('Name', this.organizationForm.value.name || '');
    formData.append('City', this.organizationForm.value.city || '');
    formData.append('Country', this.organizationForm.value.country || '');
    formData.append('Adress', this.organizationForm.value.adress || '');
    formData.append(
      'TypeOfOrganization',
      this.organizationForm.value.typeOfOrganization || ''
    );
    formData.append(
      'CorporateAgbVAT',
      this.organizationForm.value.corporateAgbVAT || ''
    );
    formData.append('Phone1', this.organizationForm.value.phone1 || '');
    formData.append('Email', this.organizationForm.value.email || '');
    formData.append('Location', this.organizationForm.value.location || '');
    formData.append('Code', this.organizationForm.value.code || '');
    formData.append('Applications', customerApplications || '');
    formData.append(
      'InvoiceEmail',
      this.organizationForm.value.invoiceEmail || ''
    );
    formData.append(
      'BillingAgbVAT',
      this.organizationForm.value.billingAgbVAT || ''
    );
    formData.append(
      'FinanceDepartmentMail',
      this.organizationForm.value.financeDepartmentMail || ''
    );
    formData.append(
      'SupportEmail',
      this.organizationForm.value.supportEmail || ''
    );
    formData.append(
      'BillingLocation',
      this.organizationForm.value.billingLocation || ''
    );
    formData.append(
      'BillingState',
      this.organizationForm.value.billingState || ''
    );
    formData.append(
      'BillingCountry',
      this.organizationForm.value.billingCountry || ''
    );
    formData.append(
      'IsShippingAddressSameAsBilling',
      String(this.organizationForm.value.isShippingAddressSameAsBilling) ||
        'false'
    );
    formData.append(
      'IsActiveSmsMessages',
      String(this.organizationForm.value.isActiveSmsMessages) || 'false'
    );
    formData.append(
      'IsUsingOwnDermascope',
      String(this.organizationForm.value.isUsingOwnDermascope) || 'false'
    );
    formData.append(
      'LanguageCode',
      this.organizationForm.value.languageCode || ''
    );
    formData.append(
      'ApplyHeadOfficeLanguage',
      String(this.organizationForm.value.applyHeadOfficeLanguage) || 'false'
    );
    formData.append(
      'SendReportToPatient',
      String(this.organizationForm.value.sendReportToPatient) || 'false'
    );
    formData.append(
      'TimeDifference',
      this.organizationForm.value.timeDifference || ''
    );

    return formData;
  }
}
